import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { X } from 'lucide-react';

function CookieBanner() {
  const { config } = useSiteConfig();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!config) return;
    // Only show banner if analytics with cookies is enabled AND banner is on
    const needsConsent = !!config.ga4_measurement_id && config.cookie_banner_enabled !== false;
    const stored = localStorage.getItem('cookie_consent');
    if (needsConsent && !stored) setVisible(true);
  }, [config]);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
    window.location.reload(); // reload so GA loads
  };

  const handleReject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] bg-[#374963] text-white shadow-2xl border-t border-white/10"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1 text-sm leading-relaxed pr-4">
            <p>
              Utilizamos cookies analíticas para mejorar tu experiencia y medir el uso de la web.
              Puedes aceptar todas, rechazarlas, o consultar nuestra{' '}
              <Link to="/politica-cookies" className="underline text-[#e0c9b0]">Política de Cookies</Link>.
            </p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm border border-white/30 rounded-lg hover:bg-white/10 transition"
              data-testid="cookie-reject-button"
            >
              Rechazar
            </button>
            <button
              onClick={handleAccept}
              className="px-5 py-2 text-sm bg-[#785534] rounded-lg hover:bg-[#8f6741] transition font-medium"
              data-testid="cookie-accept-button"
            >
              Aceptar
            </button>
            <button
              onClick={handleReject}
              className="p-2 hover:bg-white/10 rounded-lg transition md:hidden"
              aria-label="Cerrar"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
